/**
 * Holds the most recent agent-emitted point AFTER inverse transform.
 *
 * Subscribed by anything that wants to fly a cursor / show an indicator
 * at the resolved global coords. Cleared by the consumer when no longer
 * relevant (e.g. next agent action). Kept separate from canvas-store so
 * the existing AgentCursor logic isn't disturbed by this new pipeline.
 */
import { create } from "zustand";

interface LastPoint {
  agentId: string;
  displayId: number;
  globalX: number;
  globalY: number;
  receivedAt: number;
}

interface State {
  lastPoint: LastPoint | null;
  setLastPoint: (p: LastPoint) => void;
  clear: () => void;
}

export const usePointingStore = create<State>((set) => ({
  lastPoint: null,
  setLastPoint: (p) => set({ lastPoint: p }),
  clear: () => set({ lastPoint: null }),
}));
